const state = {
  includeBaseSkins: false,
  includeGroupSkins: false,
  isDarkMode: true,
}

export default state
